import { observable } from "mobx";
import BaseService from "./geral/BaseService";
import { objetoParaQueryString } from "../utils/formatar";

const cntrConsulta = "AgendCntrConsulta";

const cntrManter = "AgendCntrManter";

const cntrDepot = "AgendCntrDepot";

const notaFiscalBase = "NotaFiscalADE";

const notaFiscalCTE = "NotaFiscalCTE";

export default class AgendamentoContainerService extends BaseService {
    constructor() {
        super(cntrConsulta);
    }

    
    listarTransportadorasImportacaoDepot() {
        return super.httpGet(`/${cntrConsulta}/ListarTransportadorasImportDepot`);
      }
    
      ValidaContainerExiste(cntr) {
        return super.httpGet(
          `/${cntrConsulta}/ValidarContainerExiste?code=${cntr}`
        );
      }
    
      ListarPreviaImportDepot(tipoConsulta, cntr) {
        return super.httpGet(
          `/${cntrConsulta}/ListarPreviaImportDepot?type=${tipoConsulta}&code=${cntr}`
        );
      }
    
      ListarTipoConsultaImportDepot(cntr) {
        return super.httpGet(
          `/${cntrConsulta}/ListarTipoConsultaImportDepot?code=${cntr}`
        );
      }
    
      filtrarPorCntr(cntr) {
        return super.httpGet(`/${cntrConsulta}/ListarContainer?cntrCode=${cntr}`);
      }
    
      ArmadoresScod() {
        return super.httpGet(`/${cntrConsulta}/ListarArmadoresScod`);                                                                           
      }
              
    
      ClientesScod(cliente) {
        return super.httpGet(`/${cntrConsulta}/ListaClientesScod?info=${cliente}`);                                                                           
      }
              
    
      ClientesScodPorId(cliente) {
        return super.httpGet(`/${cntrConsulta}/ListaClientesScodPorId?info=${cliente}`);                                      
      }
              
      ClientesScodPorIdImportador(cliente) {
        return super.httpGet(`/${cntrConsulta}/ListaClientesScodPorIdImportador?info=${cliente}`);                                   
      }
            

    obterServicos(cntr, cnpj){
        return super.httpGet(`/${cntrConsulta}/devolucaoexportacaocabotagem/verificaroS?codcntr=${cntr}&cnpj=${cnpj}`)
    }

    ISOLiberaSobremedida(iso){
        return super.httpGet(`/${cntrConsulta}/verificarisoliberasobremedida?iso=${iso}`)
    }

    listarPendencias(agendId) {
        return super.httpGet(`/${cntrConsulta}/VerificarPendencias?agendId=${agendId}`);
    }

    listarAgendamentoResumo(agendId) {
        return super.httpGet(`/${cntrConsulta}/Resumo/${agendId}`);
    }

    CarregarDetalheCancelamento(agendId) {
        return super.httpGet(`/${cntrConsulta}/DetalheCancelado/${agendId}`);
    }

    buscarParametros(tipoAgendId) {
        return super.httpGet(`/AgendCntrCamposParamController/Carregar/${tipoAgendId}`);
    }

    buscarCamposValidados(tipoAgend, terminal) {
        const obrigEntradaCntrCheio = [
            { "Agend.TranspId": true },
            { "Agend.PlacaCavalo": terminal === "RIG" ? true : false },
            { "Agend.PlacaCarret1": terminal === "RIG" ? true : false },
            { "Booking.CdTipoCntr": true },
            { "Booking.ArmId": true },
            { "Booking.Container.CdIso": true },
            { "Booking.Container.ValPesoMax": true },
            { "Booking.Container.ValPesoDoc": true },
            { "Booking.Container.ClibrsId": true },
            { "Booking.Container.MercId": terminal === "RIG" ? true : false },
            { "Booking.Container.Categoria": terminal === "RIG" ? true : false },
            { "Booking.Container.ValTara": terminal === "RIG" ? true : false },
            { "Booking.Container.CdTipoMerc": terminal === "RIG" ? true : false }
        ];

        const obrigEntradaCntrEstufagem = [
            { "Agend.TranspId": true },
            { "Agend.PlacaCavalo": terminal === "RIG" ? true : false },
            { "Agend.PlacaCarret1": terminal === "RIG" ? true : false },
            { "Booking.CdTipoCntr": true },
            { "Booking.ArmId": true },
            { "Booking.Container.Categoria": terminal === "RIG" ? true : false },
            { "Booking.Container.ValTara": terminal === "RIG" ? true : false }
        ];

        const obrigEntradaCntrVazio = [
            { "Agend.TranspId": true },
            { "Agend.PlacaCavalo": terminal === "RIG" ? true : false },
            { "Agend.PlacaCarret1": terminal === "RIG" ? true : false },
            { "Booking.CdTipoCntr": true },
            { "Booking.Container.ValTara": terminal === "RIG" ? true : false }
        ];

        var obrigRetiradas = [
            { "Agend.TranspId": true },
            { "Agend.PlacaCavalo": true },
            { "Agend.PlacaCarret1": true }
        ];

        const tiposAgendaEntrada = ["ECC", "ECTA", "ECR", "ECRTA", "ECE", "ECT", "ECCM", "ECDL"];
        // tiposAgendaRetirada = ["RCV", "RCDTC", "RCDICTAC", "RCDTA", "RCCRP", "RVI", "RVB", "RDVD", "SPN"];

        const tipoAgendaEntradaEstufagem = ["ECE"];
        const tipoAgendaEntradaMapaCheio = ["ECCM", "ECC", "ECDL"];
        const tipoAgendaEntradaVazio = ["ECV", "ECVB", "EUA", "23ECV"]

        if (tiposAgendaEntrada.indexOf(tipoAgend) > -1) {
            if (tipoAgendaEntradaMapaCheio.includes(tipoAgend))
                return obrigEntradaCntrCheio;
            else if (tipoAgendaEntradaEstufagem.includes(tipoAgend))
                return obrigEntradaCntrEstufagem
            else if (tipoAgendaEntradaVazio.includes(tipoAgend))
                return obrigEntradaCntrVazio
            else
                return obrigEntradaCntrCheio
        } else {
            return obrigRetiradas;
        }
    }

    buscarCamposObrigatorios(tipoAgend, terminal) {
        const obrigEntradaCntrCheio = [
            { "Agend.TranspId": true },
            { "Agend.PlacaCavalo": terminal === "SSA" ? false : true },
            { "Agend.PlacaCarret1": terminal === "SSA" ? false : true },
            { "Booking.CdTipoCntr": true },
            { "Booking.ArmId": true },
            { "Booking.Container.ValPesoMax": true },
            { "Booking.Container.ClibrsId": true },
            { "Booking.Container.CdIso": true },
            { "Booking.Container.MercId": true }
        ];

        var obrigRetiradas = [
            { "Agend.TranspId": true },
            { "Agend.PlacaCavalo": true },
            { "Agend.PlacaCarret1": true }
        ];

        let tiposAgendaEntrada = ["ECC", "ECV", "ECTA", "ECR", "ECRTA", "ECE", "ECT", "ECCM", "ECVB", "EUA", "ECDL", "23ECV"];
        // tiposAgendaRetirada = ["RCV", "RCDTC", "RCDICTAC", "RCDTA", "RCCRP", "RVI", "RVB", "RDVD", "SPN"];

        if (tiposAgendaEntrada.indexOf(tipoAgend) > -1) {
            return obrigEntradaCntrCheio;
        } else {
            return obrigRetiradas;
        }
    }
    salvarDocumentoNotaFiscal(doc, dado, criarFilho = "N") {
        let filtros = "?";
        let extensao = null
        if (dado)
            extensao = dado.split('.').pop();
        filtros = filtros.concat(`tipoDoArquivo=${extensao}`);
        if (dado) filtros = filtros.concat(`&nomeDoArquivo=${dado}`);

        filtros = filtros.replace("?&", "?");
        return super.httpPost(`/${cntrManter}/SalvarArquivoNota/${filtros}`, doc)
    };
    excluirDocumentoNotaNaoObrigatoria(notaId) {
        return super.httpDelete(`/${cntrManter}/ExcluirDocumentoNota/${notaId}`)
    }    
    buscarDocumento = (idDocumento) => {
        return `${urlApi}/${cntrManter}/DownloadDocumento/${idDocumento}`;
    };
    buscarCamposObrigatoriosNotas(bagagemFlag = false) {
        {/**TODO: implementar filtros RIG e SSA*/ }


        let notasFiscais = [];

        if (bagagemFlag) {
            notasFiscais =
                [
                    { Cod: "NumNotaTransp", Label: "Número DUE" },
                    { Cod: "QtdTotal", Label: "Quantidade Total" },
                    { Cod: "TranspId", Label: "Transportadora" },
                    { Cod: "DatEmissao", Label: "Data de Emissão" },
                    { Cod: "DatSaidaEmissor", Label: "Data de Saída" },
                    { Cod: "RazaoSocialDest", Label: "Razão Social Destinatário" },
                    { Cod: "ValTotal", Label: "Valor Total" },
                    { Cod: "Cnpjs", Label: "CNPJ Emissor" },
                    { Cod: "CdPaisDest", Label: "País" },
                    { Cod: "NomCidadeDest", Label: "Cidade" }
                ];
        } else {
            notasFiscais =
                [
                    { Cod: "ChaveNfe", Label: "Chave da Nota" },
                    { Cod: "NumNotaTransp", Label: "Número da Nota" },
                    { Cod: "SerieNotaTransp", Label: "Série" },
                    { Cod: "QtdTotal", Label: "Quantidade Total" },
                    { Cod: "TranspId", Label: "Transportadora" },
                    { Cod: "DatEmissao", Label: "Data de Emissão" },
                    { Cod: "DatSaidaEmissor", Label: "Data de Saída" },
                    { Cod: "RazaoSocialDest", Label: "Razão Social Destinatário" },
                    { Cod: "ValTotal", Label: "Valor Total" },
                    { Cod: "Cnpjs", Label: "CNPJ Emissor" },
                    { Cod: "CdPaisDest", Label: "País" },
                    { Cod: "NomCidadeDest", Label: "Cidade" }
                ];
        }

        return notasFiscais;
    }

    buscarAgendamentoPorId(id) {
        return super.httpGet(`/${cntrManter}/CarregarAgend?agendId=${id}`);
    }

    async buscarDATPorAgenda(agendaId) {
        return super.httpGet(`/${cntrConsulta}/CarregarDATAgend?agendId=${agendaId}`);
    }

    buscarTipoAgendaPorId(tipoId) {
        return super.httpGet(`/${cntrConsulta}/CarregarAgendTipo?tipoAgendId=${tipoId}`);
    }

    buscarContainersPorAgenda(agendaId) {
        return super.httpGet(`/${cntrConsulta}/ListarContainers?agendId=${agendaId}`);
    }

    buscarLacresPorAgendaContainerId(agendaId) {
        return super.httpGet(`/${cntrConsulta}/ListarLacres?agendCntrId=${agendaId}`);
    }

    buscarNotasFiscaisPorAgenda(agendaId) {
        return super.httpGet(`/${cntrConsulta}/ListarNotasPorAgend?agendId=${agendaId}`);
    }

    listar(filtro) {
        let str = objetoParaQueryString(filtro);
        return super.httpGet(`/${cntrConsulta}/Pesquisar?${str}`);
    }

    listarTamanhoCntr() {
        return super.httpGet(`/${cntrConsulta}/ListarTamanhos`);
    }

    listarCategoriasCNH() {
        return super.httpGet(`/${cntrManter}/ListarCategoriasCnh`);
    }

    buscarMotoristaPorCNH(cnh) {
        return super.httpGet(`/${cntrManter}/CarregarMotoristaPorCnh/${cnh}`);
    }

    buscarDadosPorBooking(numBooking) {
        return super.httpGet(`/${cntrManter}/CarregarCamposPorBooking/${numBooking}`);
    }

    buscarDadosPorBookingDepot(numBooking) {
        return super.httpGet(`/${cntrDepot}/CarregarDadosBooking/${numBooking}`);
    }

    buscarTiposCntrPorBookingDepot(numBooking) {
        return super.httpGet(`/${cntrDepot}/ListarTiposCntrSimples/${numBooking}`);
    }

    buscarDadosPorTipoCntrDepot(bookingCntrId) {
        return super.httpGet(`/${cntrDepot}/CarregarDadosTipoCntr/${bookingCntrId}`);
    }

    buscarDadosPorContainer(numContainer) {
        return super.httpGet(`/${cntrManter}/CarregarDadosContainer?container=${numContainer}`);
    }

    listarTransportadorasPorMembership() {
        return super.httpGet(`/${cntrManter}/ListarTransportadorasPorMembership`);
    }

    listarTransportadorasPorMembershipDepot() {
        return super.httpGet(`/${cntrDepot}/ListarTransportadora`);
    }
    
    listarIsoDesistencia() {
        return super.httpGet(`/${cntrDepot}/ListarIso`);
    }

    listarArmadoresDesistencia() {
        return super.httpGet(`/${cntrDepot}/ListarArmadores`);
    }

    listarOperacaoDesistencia() {
        return super.httpGet(`/${cntrDepot}/ListarOperacao`);
    }

    carregarCnpjDesistencia(cnpj) {
        return super.httpGet(`/${cntrDepot}/CarregarParceiroPorCnpj?cnpj=${cnpj}`);
    }

    listarTransportadoras() {
        return super.httpGet(`/Transportadoras`);
    }

    recuperarCnpjTransportadora = (transpId)=>{
        return this.httpGet(`${cntrManter}/Transp/RecuperaCNPJTransp?transpid=${transpId}`)
    }

    listarOperacoes(tipoAgendId, flagTrem) {
        return super.httpGet(`/${cntrManter}/ListarOperRIG/${tipoAgendId}/${flagTrem}`);
    }

    listarDatas(tipoAgendId) {
        return super.httpGet(`/${cntrManter}/ListarDatasDisponiveisPorTipo/${tipoAgendId}`);
    }

    listarHoras(tipoAgendId, data) {
        return super.httpGet(`/${cntrManter}/ListarHorasDisponiveisPorTipoData/${tipoAgendId}/${data}`);
    }

    listarTipoAgendamento() {
        return super.httpGet(`/${cntrConsulta}/ListarTipos`);
    }

    listarTipoContainer(numBooking) {
        return super.httpGet(`/${cntrManter}/ListarTiposCntr/${numBooking}`);
    }

    listarStatus() {
        return super.httpGet(`/${cntrConsulta}/ListarStatus`);
    }

    listarArmadores(oper, flagTrem) {
        return super.httpGet(`/${cntrManter}/ListarArmadores/${oper}/${flagTrem}`);
    }

    armadorPermiteCriacaoBooking(armadorId) {
        return super.httpGet(`/${cntrManter}/PermiteCriacaoBooking/${armadorId}`);
    }

    listarPortos(armadorId, oper) {
        return super.httpGet(`/${cntrManter}/ListarPortos/?armadorId=${armadorId}&oper=${oper}`);
    }

    listarDestinos() {
        return super.httpGet(`/${cntrManter}/ListarDestinoOrigem`);
    }

    listarISOs(tipoCntr, booking) {
        return super.httpGet(`/${cntrManter}/ListarISOsCntr/${tipoCntr}/${booking}`);
    }

    buscarClientePorCnpj(cnpj) {
        return super.httpGet(`/${cntrManter}/CarregarClientePorCnpj/${cnpj}`);
    }

    buscarMensagensParaCliente(codIdentificador) {
        return super.httpGet(`/${cntrManter}/MensagemAlertaCampoCliente/${codIdentificador}`);
    }

    listarCategorias() {
        return super.httpGet(`/Moviment/ListarCategorias`);
    }

    listarArmadoresVazio(agendTipoId) {
        return super.httpGet(`/${cntrManter}/ListarArmadoresVazios?agendTipoId=${agendTipoId}`);
    }

    listarOperacoesVazio(armador, agendTipoId) {
        return super.httpGet(`/${cntrManter}/ListarOperacoesVazios?lineOpId=${armador}&agendTipoId=${agendTipoId}`);
    }

    listarTiposCntrVazio(armador, oper) {
        return super.httpGet(`/${cntrManter}/ListarTipoCntrVazios?lineOpId=${armador}&vesselVisitId=${oper}`);
    }

    listarShipmentsVazio(armador, oper, tipoCntr) {
        return super.httpGet(`/${cntrManter}/ListarShipmentNumber?lineOpId=${armador}&vesselVisitId=${oper}&tipoCntr=${tipoCntr}`);
    }

    listarDocumentosRetirada(transpId, codTipo) {
        return super.httpGet(`/${cntrManter}/ListarDIsPorTranspIdTipoDI/${transpId}/${codTipo}`);
    }

    listarContainersRetirada(di) {
        return super.httpGet(`/${cntrManter}/ListarCntrPorDi/${di}`);
    }

    buscarQtdDisponivelVazio(armador, oper, tipoCntr, agendId) {
        return super.httpGet(`/${cntrManter}/CarregarQtdDisponivelVazios?armId=${armador}&vesselVisitId=${oper}&tipoCntr=${tipoCntr}&agendId=${agendId}`);
    }

    buscarMercadoriaPorNcm(ncm) {
        return super.httpGet(`/${cntrManter}/CarregarMercadoriaPorNcm?ncm=${ncm}`);
    }

    buscarTiposMercadoria(tipoAgendId, flagIsoRefrig) {
        return super.httpGet(`/${cntrManter}/ListarTiposMercadoria?tipoAgendId=${tipoAgendId}&flagIsoRefrig=${flagIsoRefrig}`);
    }

    validarISO(ISO) {
        return super.httpGet(`/${cntrManter}/CarregarISOCntr/${ISO}`);
    }

    salvarAgendamento(agendamento, isDepot) {
        return super.httpPost(`/${isDepot ? cntrDepot : cntrConsulta}/SalvarAgend`, agendamento);
    }
    carregarNotaPorAgenda(tipoAgendId) {
        return super.httpGet(`/${cntrConsulta}/CarregarNota?tipoAgendId=${tipoAgendId}`)
    }
    carregarArquivosPorNotaId(notaId) {
        return super.httpGet(`/${cntrConsulta}/CarregarArquivos?notaId=${notaId}`)
    }
    cancelarAgendamento(id) {
        return super.httpPost(`/${cntrConsulta}/CancelarAgend`, id);
    }

    liberarEspecial(agend) {
        return super.httpPost(`/${cntrConsulta}/LiberarEspecial`, agend);
    }

    liberarManualDepot(agendId, motivo) {
        return super.httpGet(`/${cntrDepot}/LiberarManual?agendId=${agendId}&motivo=${motivo}`);
    }

    cancelarDepot(agendId, motivo) {
        return super.httpGet(`/${cntrDepot}/CancelarAgendDepot?agendId=${agendId}&motivo=${motivo}`);
    }

    reenviarEmailBat(agendId) {
        return super.httpGet(`/${cntrConsulta}/ReenviarEmailBat/${agendId}`);
    }

    verificarEdicaoAgendamento(agendId) {
        return super.httpGet(`/${cntrConsulta}/VerificarEdicaoAgendamento/${agendId}`);
    }

    xmlImportNota(xmlDoc) {
        return super.httpPost(`/${notaFiscalBase}/XmlImportacaoNota?request=""`, xmlDoc)
    }

    xmlImportNotaCTE(xmlDoc) {
        return super.httpPost(`/${notaFiscalCTE}/XmlImportacaoNota?request=""`, xmlDoc)
    }

    listarTransportadorasNotaFiscal(membershipUserId) {
        return super.httpGet(`/${notaFiscalBase}/ListarTransportadoras/`)
    }

    listarPaises() {
        return super.httpGet(`/Utils/listar-pais`);
    }

    listarUFs(pais) {
        return super.httpGet(`/Utils/listar-estado?pais=${pais}`);
    }

    buscarParceiro(CNPJ) {
        return super.httpGet(`/${notaFiscalBase}/RetornarParceiro?cnpj=${CNPJ}`);
    }

    listarNotas(filtro) {
        let str = objetoParaQueryString(filtro);
        return super.httpGet(`/${notaFiscalBase}/ListarNotas?${str}`);
    }

    salvarNota(notaFiscal) {
        return super.httpPost(`/${notaFiscalBase}/Inserir`, notaFiscal);
    }

    carregarNota(id) {
        return super.httpGet(`/${notaFiscalBase}/CarregarNotaFiscal?notaId=${id}`);
    }

    editarNota(notaFiscal) {
        return super.httpPost(`/${notaFiscalBase}/atualizar`, notaFiscal);
    }

    excluirNotaFiscal(idNota) {
        let str = objetoParaQueryString(idNota);
        return super.httpGet(`/${notaFiscalBase}/Excluir?${str}`);
    }

    consultarContainer(containerId) {
        {/**TODO: remover essa chamada desse lugar */ }
        return super.httpGet(`/Container/Detalhe?cntrNbr=${containerId}`);
    }

    ListarNotasPorCntrBooking(listaKeyValue) {
        return super.httpPost(`/${cntrConsulta}/ListarNotasPorCntrBooking`, listaKeyValue);
    }

    ObterHoraLimiteAgendamento(codCntr, numBooking, codIso, terminal, dataAgend, tipoAgend) {
        //ObterHoraLimiteDeadLine/{codCntr}/{numBooking}/{codIso}/{terminal}/{tipoAgend}
        return super.httpGet(`/${cntrConsulta}/ObterHoraLimiteDeadLine?codCntr=${codCntr}&numBooking=${numBooking}&codIso=${codIso}&terminal=${terminal}&dataAgend=${dataAgend}&tipoAgend=${tipoAgend}`);
    }

    getSample() {
        return this.sample;
    }

    parseBookings(jContainers) {
        var listaBookings = new observable([]);

        if(process.env.rig){

            let valid = { CnpjCliente_lblNaoExiste: "", CnpjRespOva_lblNaoExiste: "", NCM_lblNaoExiste: "", ISO_lblNaoExiste: "", Umidade_Bloqueado: true };
            let bookingList = [];

            jContainers.forEach(cntr =>{

                let cntrBooking = {
                    "Id": cntr.Id,
                    "AgendId": cntr.AgendId,
                    "CodCntr": cntr.CodCntr,
                    "NumCtrc": cntr.NumCtrc,
                    "ValPesoMax": cntr.ValPesoMax,
                    "Categoria": cntr.Categoria,
                    "ValPesoDoc": cntr.ValPesoDoc,
                    "FlgTran": cntr.FlgTran,
                    "Orig": cntr.Orig,
                    "EadiId": cntr.EadiId,
                    "ClibrsId": cntr.ClibrsId,
                    "ClibrsIdCons": cntr.ClibrsIdCons,
                    "CdTipoCntr": cntr.CdTipoCntr,
                    "OverdmsDir": cntr.OverdmsDir,
                    "OverdmsEsq": cntr.OverdmsEsq,
                    "OverdmsFre": cntr.OverdmsFre,
                    "OverdmsTra": cntr.OverdmsTra,
                    "ValTmpIdea": cntr.ValTmpIdea,
                    "ValUmid": cntr.ValUmid,
                    "ValVent": cntr.ValVent,
                    "OverdmsTop": cntr.OverdmsTop,
                    "CdIso": cntr.CdIso,
                    "MercId": cntr.MercId,
                    "ValTara": cntr.ValTara,
                    "PrmcrgprgId": cntr.PrmcrgprgId,
                    "CdTipoMerc": cntr.CdTipoMerc,
                    "IndPagtoTranAduan": cntr.IndPagtoTranAduan,
                    "FlgVistAduan": cntr.FlgVistAduan,
                    "NumDde": cntr.NumDde,
                    "FlgNaoNota": cntr.FlgNaoNota,
                    "CodGenset": cntr.CodGenset,
                    "ValPesoLiq": cntr.ValPesoLiq,
                    "ClibrsIdCobrade": cntr.ClibrsIdCobrade,
                    "DepotId": cntr.DepotId,
                    "IdCommoditie": cntr.IdCommoditie,
                    "IdUn": cntr.IdUn,
                    "TrkVstApptNbr": cntr.TrkVstApptNbr,
                    "ApptNbr": cntr.ApptNbr,
                    "IndStatus": cntr.IndStatus,
                    "QtdRetirada": cntr.QtdRetirada,
                    "FlgMapa": cntr.FlgMapa,
                    "CntrStatus": cntr.CntrStatus,
                    "FlgVgm": cntr.FlgVgm,
                    "ObsVgm": cntr.ObsVgm,
                    "FlgTranAduan": cntr.FlgTranAduan,
                    "FlgGensetAcoplado": cntr.FlgGensetAcoplado,
                    "CnpjRespOva": cntr.CnpjRespOva,
                    "RazSocialRespOva": cntr.RazSocialRespOva,
                    "CnpjCliente": cntr.CnpjCliente,
                    "RazSocialCliente": cntr.RazSocialCliente,
                    "FlatRack": cntr.FlatRack, // PRECISA SER FALSO
                    "HouveAltBookingCntr": cntr.HouveAltBookingCntr, // PRECISA SER FALSO
                    "Lacres": cntr.Lacres ? cntr.Lacres : [],
                    "UNs": cntr.UNs,
                    "DiId": cntr.DiId,
                    "DiRetirada": cntr.DiRetirada,
                    "Armador": cntr.Armador,
                    "Operacao": cntr.Operacao,
                    "Tipo": cntr.Tipo,
                    "ShipmentNumber": cntr.ShipmentNumber,
                    "ShipmentNumberObj": cntr.ShipmentNumberObj,
                    "VesselvisitId": cntr.VesselvisitId,
                    "ArmId": cntr.ArmId,
                    "NumBooking": cntr.NumBooking,
                    valid
                };
                let visit = bookingList.find(x=> x.VesselvisitId == cntr.VesselvisitId && x.NumBooking == cntr.NumBooking);

                if(visit){
                    visit.containers.push(cntrBooking);
                }else{
                    let booking = {
                        NumBooking: cntr.NumBooking,
                        CdPorto: cntr.CdPorto,
                        LcCdLoc: cntr.LcCdLoc,
                        VesselvisitId: cntr.VesselvisitId,
                        ArmId: cntr.ArmId,
                        ApelidoArmador: cntr.ApelidoArmador,
                        IdViagemDtPrev: cntr.IdViagemDtPrev,
                        NomePorto: cntr.NomePorto,
                        containers: [cntrBooking],
                        inicializado: true,
                        containerAtivo: 0,
                        bookingExistente: null,
                        collapsed: false
                    };

                    bookingList.push(booking);
                }
            });

            bookingList.forEach(booking => listaBookings.push(booking));

        }else{
            var listaPorBookings = [];

            let valid = { CnpjCliente_lblNaoExiste: "", CnpjRespOva_lblNaoExiste: "", NCM_lblNaoExiste: "", ISO_lblNaoExiste: "", Umidade_Bloqueado: true }
    
            for (let x = 0; x < jContainers.length; x++) {
                const jCntr = jContainers[x];
    
                if (["RCDICTAC", "RCDTA", "RCCRP", "RDEC", "RDVD"].indexOf(jCntr.TipoAgendCodIdentificador) > -1
                    || ["RCDTC"].indexOf(jCntr.TipoAgendCodI) > -1 && process.env.rig) {
                    listaPorBookings = _.remove(jContainers, { "CodCntr": jCntr.CodCntr });
                } else {
                    listaPorBookings = _.remove(jContainers, { "NumBooking": jCntr.NumBooking });
                }
    
                x = x - 1;
    
                var booking = {
                    NumBooking: listaPorBookings[0].NumBooking,
                    CdPorto: listaPorBookings[0].CdPorto,
                    LcCdLoc: listaPorBookings[0].LcCdLoc,
                    VesselvisitId: listaPorBookings[0].VesselvisitId,
                    ArmId: listaPorBookings[0].ArmId,
                    ApelidoArmador: listaPorBookings[0].ApelidoArmador,
                    IdViagemDtPrev: listaPorBookings[0].IdViagemDtPrev,
                    NomePorto: listaPorBookings[0].NomePorto,
                    containers: [],
    
                    inicializado: true,
                    containerAtivo: 0,
                    bookingExistente: null,
                    collapsed: false
                }
    
                listaPorBookings.forEach(book => {
                    booking.containers.push({
                        "Id": book.Id,
                        "AgendId": book.AgendId,
                        "CodCntr": book.CodCntr,
                        "NumCtrc": book.NumCtrc,
                        "ValPesoMax": book.ValPesoMax,
                        "Categoria": book.Categoria,
                        "ValPesoDoc": book.ValPesoDoc,
                        "FlgTran": book.FlgTran,
                        "Orig": book.Orig,
                        "EadiId": book.EadiId,
                        "ClibrsId": book.ClibrsId,
                        "ClibrsIdCons": book.ClibrsIdCons,
                        "CdTipoCntr": book.CdTipoCntr,
                        "OverdmsDir": book.OverdmsDir,
                        "OverdmsEsq": book.OverdmsEsq,
                        "OverdmsFre": book.OverdmsFre,
                        "OverdmsTra": book.OverdmsTra,
                        "ValTmpIdea": book.ValTmpIdea,
                        "ValUmid": book.ValUmid,
                        "ValVent": book.ValVent,
                        "OverdmsTop": book.OverdmsTop,
                        "CdIso": book.CdIso,
                        "MercId": book.MercId,
                        "ValTara": book.ValTara,
                        "PrmcrgprgId": book.PrmcrgprgId,
                        "CdTipoMerc": book.CdTipoMerc,
                        "IndPagtoTranAduan": book.IndPagtoTranAduan,
                        "FlgVistAduan": book.FlgVistAduan,
                        "NumDde": book.NumDde,
                        "FlgNaoNota": book.FlgNaoNota,
                        "CodGenset": book.CodGenset,
                        "ValPesoLiq": book.ValPesoLiq,
                        "ClibrsIdCobrade": book.ClibrsIdCobrade,
                        "DepotId": book.DepotId,
                        "IdCommoditie": book.IdCommoditie,
                        "IdUn": book.IdUn,
                        "TrkVstApptNbr": book.TrkVstApptNbr,
                        "ApptNbr": book.ApptNbr,
                        "IndStatus": book.IndStatus,
                        "QtdRetirada": book.QtdRetirada,
                        "FlgMapa": book.FlgMapa,
                        "CntrStatus": book.CntrStatus,
                        "FlgVgm": book.FlgVgm,
                        "ObsVgm": book.ObsVgm,
                        "FlgTranAduan": book.FlgTranAduan,
                        "FlgGensetAcoplado": book.FlgGensetAcoplado,
                        "CnpjRespOva": book.CnpjRespOva,
                        "RazSocialRespOva": book.RazSocialRespOva,
                        "CnpjCliente": book.CnpjCliente,
                        "RazSocialCliente": book.RazSocialCliente,
                        "FlatRack": book.FlatRack, // PRECISA SER FALSO
                        "HouveAltBookingCntr": book.HouveAltBookingCntr, // PRECISA SER FALSO
                        "Lacres": book.Lacres ? book.Lacres : [],
                        "UNs": book.UNs,
                        "DiId": book.DiId,
                        "DiRetirada": book.DiRetirada,
    
                        "Armador": book.Armador,
                        "Operacao": book.Operacao,
                        "Tipo": book.Tipo,
                        "ShipmentNumber": book.ShipmentNumber,
                        "ShipmentNumberObj": book.ShipmentNumberObj,
                        "VesselvisitId": book.VesselvisitId,
                        "ArmId": book.ArmId,
    
                        "NumBooking": book.NumBooking,
    
                        valid
                    })
                })
    
                listaBookings.push(booking);
            }
        }

        return listaBookings;
    }



    sample = {
        "Agend": {
            "Id": 0,
            "TranspId": null,
            "TipoAgendId": null,
            "IndStatus": null,
            "DatAgend": null,
            "HoraAgend": null,
            "Cnh": null,
            "PlacaCavalo": "",
            "PlacaCarret1": "",
            "PlacaCarret2": "",
            "MembershipuseridIncl": null,
            "DatIncl": null,
            "DatChegada": null,
            "FlgGold": null,
            "CdLoc": null,
            "DatUsuAlt": null,
            "UsuAlt": null,
            "OperTrem": null,
            "CodVagao": null,
            "DataLibEspec": null,
            "HoraLibEspec": null,
            "DataAntesLib": null,
            "HoraAntesLib": null,
            "DatUltimoNotify": null,
            "DriverName": null,
            "DriverLicense": null,
            "DriverCardId": null,
            "DescIndStatus": null
        },
        "Motorista": {
            "Id": 0,
            "CategCnh": null,
            "Cpf": 0,
            "Identidade": 0,
            "OrgEmissId": 0,
            "Nome": null,
            "AgendMotoristaId": null,
            "N4DriverLicense": null,
            "N4CardId": null
        },
        "ListaContainer": [
            {
                "Id": 0,
                "AgendId": 0,
                "CodCntr": null,
                "NumBooking": null,
                "NumCtrc": null,
                "CdTipoCntr": null,
                "ValPesoMax": 0,
                "ValPesoDoc": 0,
                "Categoria": null,
                "FlgTran": "N",
                "Orig": null,
                "EadiId": null,
                "CdPorto": null,
                "LcCdLoc": null,
                "ClibrsId": 0,
                "ClibrsIdCons": 0,
                "OverdmsDir": null,
                "OverdmsEsq": null,
                "OverdmsFre": null,
                "OverdmsTra": null,
                "ValTmpIdea": null,
                "ValUmid": null,
                "ValVent": null,
                "OverdmsTop": null,
                "CdIso": null,
                "MercId": 0,
                "ValTara": 0,
                "PrmcrgprgId": null,
                "CdTipoMerc": null,
                "IndPagtoTranAduan": null,
                "FlgVistAduan": null,
                "NumDde": null,
                "FlgNaoNota": null,
                "CodGenset": null,
                "ValPesoLiq": null,
                "ClibrsIdCobrade": null,
                "DepotId": null,
                "IdCommoditie": null,
                "VesselvisitId": null,
                "IdUn": null,
                "ArmId": 0,
                "TrkVstApptNbr": null,
                "ApptNbr": null,
                "IndStatus": null,
                "DiRetirada": null,
                "QtdRetirada": null,
                "FlgMapa": null,
                "CntrStatus": null,
                "FlgVgm": null,
                "ObsVgm": null,
                "FlgTranAduan": "N",
                "FlgGensetAcoplado": null,
                "CnpjRespOva": null,
                "RazSocialRespOva": null,
                "FlatRack": false, // PRECISA SER FALSO
                "HouveAltBookingCntr": false, // PRECISA SER FALSO
                "Lacres": null,
                "UNs": null,
                "DiId": null
            }
        ]
    }

    sampleNota = [{
        Mensagem: null,
        Sucesso: true,
        NumNotaTransp: this.codigoNovo,
        Nf: {
            Id: 0,
            Status: null,
            NumNotaTransp: null,
            SerieNotaTransp: "",
            DatEmissao: null,
            TranspId: 0,
            DatSaidaEmissor: null,
            ParcIdEmiss: 0,
            EstabIdEmiss: 0,
            CnpjDest: null,
            RazaoSocialDest: null,
            CdPaisDest: null,
            CdUnidadeFedDest: null,
            NomCidadeDest: null,
            InscrEstadDest: null,
            Operacao: 0,
            CodCfop: 0,
            ValIpi: 0,
            ValIcms: 0,
            QtdTotal: 0,
            ValTotal: 0,
            PesoTotal: 0,
            Cnpjs: null,
            Membershipuserid: 0,
            NumBooking: null,
            ChaveNfe: "",
            FlagBagagem: null,
            XmlNota: null,
            Ruc: null,
            StatusDue: null,
            TruckVisitAppointmentNbr: 0,
            FlagBitrem: null
        },
        ListaCntr: [],
        ListaItem: [],
        CnpjDestinatario_lblNaoExiste: "", CnpjEmissor_lblNaoExiste: "", addManual: true
    }]

    nfCntr = {
        Id: 0,
        NotaFiscalTranspId: 0,
        CntId: 0,
        CodCntr: null,
        Status: null,
        NumGuiaCaminhao: null,
        NumBooking: null,
        CnpjCobrade: null,
        UnitGkey: 0,
        StatusDue: null,
        IndExcluido: null
    };

    nfItem = {
        Id: 0,
        NotaFiscalTranspId: 0,
        MercId: 0,
        QtdItem: 0,
        ValItem: 0,
        PesoItem: 0,
        NcmMerc: null,
        CodCfop: 0,
        IndExcluido: null
    };
}


// WEBPACK FOOTER //
// ./src/services/AgendamentoContainerService.js